import styled, { css } from 'styled-components';
import { priceLabelStylingType, priceLabel } from './types';

type PriceLabelProps = {
  bold?: boolean;
  styling: priceLabelStylingType;
};

export const PriceLabel = styled.span.attrs({ 'data-test': 'PriceLabel' })<
  PriceLabelProps
>(
  props => css`
    font-size: inherit;
    font-weight: ${props.bold ? '600' : 'inherit'};

    ${props.styling === priceLabel.PRIMARY &&
      css`
        color: ${props.theme.colors.base700};
      `}

    ${props.styling === priceLabel.SECONDARY &&
      css`
        color: ${props.theme.colors.base600};
      `}

    ${props.styling === priceLabel.LIGHTEN &&
      css`
        color: ${props.theme.colors.base500};
      `}

    ${props.styling === priceLabel.CAMPAIGN &&
      css`
        color: ${props.theme.colors.negative700};
      `}
  `
);
